import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import { hasProductAccess } from '../../../lib/product-catalog';
import CatalogCard from '../catalog-card';
import productCatalogData from '../product-catalog-data.json';

import type { ProductCatalogItem } from '../../../../../types/product-catalog';
import type { Obligation } from '../../../../../types/ztb';

const products = productCatalogData.products as Array<ProductCatalogItem>;

type Props = {
  currentProductId: string;
  recommendedProductIds: Array<string>;
  obligations: Array<Obligation>;
  onContactClick: (item: ProductCatalogItem) => void;
};

const ProductDetailRecommendations = ({
  currentProductId,
  recommendedProductIds,
  obligations,
  onContactClick,
}: Props) => {
  const recommendedProducts = recommendedProductIds
    .filter((id) => id !== currentProductId)
    .map((id) => products.find((product) => product.id === id))
    .filter((product): product is ProductCatalogItem => product != null);

  if (!recommendedProducts.length) return null;

  return (
    <div data-ref='buy.product-detail.recommendations'>
      <SRow>
        <SCol>
          <h2 data-ref='buy.product-detail.recommendations.header'>
            {t('client.product-catalog.recommended-heading')}
          </h2>
          <p data-ref='buy.product-detail.recommendations.subheader'>
            {t('client.product-catalog.recommended-subheading')}
          </p>
        </SCol>
      </SRow>
      <SRow>
        {recommendedProducts.map((product) => (
          <SCol key={product.id} data-ref={`buy.product-detail.recommendations.${product.slug}.tile`} span='6'>
            <CatalogCard
              item={product}
              hasAccess={hasProductAccess(product.productCatalogId, obligations)}
              onContactClick={onContactClick}
            />
          </SCol>
        ))}
      </SRow>
    </div>
  );
};

export default ProductDetailRecommendations;
